export default "__VITE_ASSET__DnZfO0vd__"